<template>
  <div class="pt-2 safe-margin">
    <v-divider></v-divider>
    <div class="my-4 text-center" id="quizNext">
      <span>
        {{ $t('GAME.QUIZ.TYPE_OF_HATE') }}
      </span>
      <strong>
        {{ $localized(question, 'explanation') }}
      </strong>
    </div>
    <BaseButton
      color="success lighten-2"
      @click="$emit('next')"
    >
      {{ $t('GAME.QUIZ.ANSWERED_NEXT') }}
    </BaseButton>

    <v-btn
      outlined
      large
      block
      rounded
      class="my-2"
      :href="question.source"
      target="_blank"
      v-if="hasReadMore"
      @click="$track('view_source', 'quiz')"
    >
      {{ $t('GAME.QUIZ.READ_MORE') }}
    </v-btn>
  </div>
</template>

<style scoped>
.safe-margin {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
</style>

<script>
export default {
  name: 'QuizAnswerResult',
  props: {
    question: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Number,
      default: -1,
    },
  },
  computed: {
    hasReadMore() {
      return this.question.source && this.$i18n.locale === 'es';
    },
  },
  mounted() {
    this.$vuetify.goTo('#quizNext');
  },
};
</script>
